import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Redo2, Undo2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ToolbarButton } from "./ToolbarButton";
export function UndoRedoButtons({ onUndo, onRedo, canUndo, canRedo }) {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            onUndo && /*#__PURE__*/ _jsx(ToolbarButton, {
                onClick: onUndo,
                disabled: !canUndo,
                tooltip: t("flowKit.toolbar.undo"),
                children: /*#__PURE__*/ _jsx(Undo2, {
                    className: "h-4 w-4"
                })
            }),
            onRedo && /*#__PURE__*/ _jsx(ToolbarButton, {
                onClick: onRedo,
                disabled: !canRedo,
                tooltip: t("flowKit.toolbar.redo"),
                children: /*#__PURE__*/ _jsx(Redo2, {
                    className: "h-4 w-4"
                })
            })
        ]
    });
}

//# sourceMappingURL=UndoRedoButtons.js.map